import AutoCompleteSearch from './AutoCompleteSearch'

export default AutoCompleteSearch
